import React, { useMemo } from 'react'
import cx from 'classnames'
import { useAppDispatch } from 'reduxTyped'
import { Icon, l, palettes } from '@manychat/manyui'

import * as buttonActions from 'common/builder/actions/buttonActions'
import cm from 'common/builder/components/builder/NextStepPane/NextStepPane.module.css'
import { ButtonType } from 'common/builder/constants/ButtonType'
import { ChannelType } from 'common/core/constants/ChannelType'

interface SmartLinksPaneProps {
  builderId: string
  buttonId: string
  type: ButtonType
  channel: ChannelType | null
  className: string
  readonly?: boolean
}

const SmartLinksPane = (props: SmartLinksPaneProps) => {
  const { builderId, buttonId, readonly, type, channel } = props

  const dispatch = useAppDispatch()
  const handleDelete = () => {
    dispatch(
      buttonActions.resetButtonNextStep(builderId, buttonId, {
        keepTarget: false,
        keepType: false,
      }),
    )
  }

  const config = useMemo(() => {
    const defaultConfig = {
      label: l.translate('Open Messenger'),
      icon: <Icon.MessengerChannel size={26} color={palettes.semantic.primary} />,
    }

    if (type === ButtonType.CROSS_CHANNEL_CONTENT && channel === ChannelType.INSTAGRAM) {
      return {
        icon: <Icon.InstagramChannel size={26} color={palettes.semantic.primary} />,
        label: l.translate('Open Instagram'),
      }
    }

    return defaultConfig
  }, [channel, type])

  return (
    <div className={cx(cm.wrap, cm.content, props.className, 'd-flex')}>
      <div className="d-flex col-12">
        <div className="d-flex col-8 col-offset-1 align-center">
          {config.icon}
          <span className="m-l text-subheading">{config.label}</span>
        </div>
        <div
          className={cx(
            'd-flex align-center justify-center col-2 col-offset-1 b-l pointer',
            cm.smartLink,
            {
              [cm.readonly]: readonly,
            },
          )}
        >
          <Icon.Close size={24} onClick={handleDelete} />
        </div>
      </div>
    </div>
  )
}

export default SmartLinksPane as React.FunctionComponent<SmartLinksPaneProps>
